export default __webpack_public_path__ + "static/start_screen_system-d53649128c5d899530c16cfa0e89accf.mp4";